// extracted by css-extract-rspack-plugin
module.exports =  {"base":"Footer__base--YO3aL","nav":"Footer__nav--Y1Vzh","menu":"Footer__menu--sBzOB","copyright":"Footer__copyright--BlcpY"};